import React, { useState } from 'react';
import CustomModal from '../components-library/CustomModal';
import { MODAL_SIZES } from '../services/exports/Constants';
import OtpFlow from '../components-library/auth/OtpFlow';
import CustomButton from '../components-library/buttons/CustomButton';
import { useTranslation } from 'react-i18next';
import useAppState from '../hooks/global/useAppState';
import useAppMethods from '../hooks/utility/useAppMethods';
import toast from 'react-hot-toast';
import useScreenType from '../hooks/utility/useScreenType';
import CloseIcon from '../assets/icons/actions/CloseIcon';
import Theme from '../components-library/Theme';

export const OTP_VERIFICATION_PHONE_NUMBER_HEADER = 'x-otp-check-phone-number';
export const OTP_VERIFICATION_PASSWORD_HEADER = 'x-otp-check-password';

export default function OtpVerificationModal() {
  const { t } = useTranslation(null, { keyPrefix: 'Modals:OtpVerificationModal' });

  const { phoneNumber, onSubmit } = useAppState().otpVerificationModalProps;
  const { toggleOtpVerificationModal } = useAppMethods();
  const { isMobile } = useScreenType();

  const [otp, setOtp] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  const _onSubmit = async () => {
    setLoading(true);
    const result = await onSubmit(otp);
    setLoading(false);

    if (!result) {
      return toast.error(t('toasts.invalid_code'));
    }

    return toggleOtpVerificationModal();
  };

  return (
    <CustomModal open size={MODAL_SIZES.SM} fullScreen={isMobile} onClose={() => toggleOtpVerificationModal()}>
      {isMobile && (
        <div className="flex justify-end p-sm pb-0">
          <button
            onClick={() => toggleOtpVerificationModal()}
            className="w-9 h-9 bg-white shadow-icon dark:shadow-none rounded-full flex justify-center items-center"
          >
            <CloseIcon color={Theme.color.black.DEFAULT} />
          </button>
        </div>
      )}
      <div className="p-md">
        <OtpFlow
          isStatic
          initialPhoneNumber={phoneNumber}
          onPasswordChange={setOtp}
          onValidationStatusChange={(result: boolean) => setIsComplete(result)}
        />
        <CustomButton
          title={t('buttons.confirm')}
          loading={loading}
          disabled={!isComplete}
          onClick={_onSubmit}
          className="mt-lg border-t-gray-100"
        />
      </div>
    </CustomModal>
  );
}
